module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAABMCAMAAAAoRQUTAAAAOVBMVEUAAABERERERERFRUVGRkZGRkZHR0dMTExERERERERERERFRUVERERERERFRUVFRUVISEhERERERERILJyjAAAAEnRSTlMA5ofCSTQaDpz079rReWpcJrHMTYQaAAAAuElEQVRIx+3Wyw6FIAxFUYsvfAv//7H3GurIxN2kDul4JQQ4bdp8WEEkWFzK/zLImK8So2MYisOjN3UtuP1247s71K3gOnXLYHMCrp/UneDm4ub+3Z1S3ARuUJc7cIvNjau6A1yrboePu90GLhkDE9VFl3sGNdWg1qByUO2TrREIIEA42n0Zfh5+cP5Cfyg4ZhxcbgV3c3G78gDgkeIeUjz2eJD6ZapBrkH+NsjBvrqyBAjrNS/sXD+kxSdhaVhBZQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/back-icon.png
// module id = 476
// module chunks = 85